module.exports = __webpack_public_path__ + "static/media/SGInnovate.086a5713.png";